<template>
    <v-col cols="12" sm="12" style="background-color: white">
        <v-container >
            <home-title :title="$t('homeBudgetCalculator')"></home-title>
            <v-row
                class="justify-center"
            >
                <v-col cols="12" class="col-md-6 col-lg-5 pr-md-12 my-md-auto">
                    <p class="text-center text-md-left py-9 big-text">
                        {{ $t('homeCalculatorSubtitle1') }}
                    </p>
                    <div class="text-center text-md-left">
                        <v-btn
                            dark
                            depressed
                            outlined
                            class="body-1 px-10 test-white caption main--yellow"
                            :to="{ path: 'calculator' }"
                        >
                            {{$t('goToCalculator')}}
                        </v-btn>
                    </div>
                </v-col>
                <v-col cols="12" class="col-md-6 col-lg-5 pl-md-12">
                    <v-img
                        :src="calculatorInfo[0].image"
                    ></v-img>
                </v-col>
            </v-row>
            <v-row
                class="justify-center"
            >
                <v-col cols="12" class="col-md-6 col-lg-5 pr-md-12">
                    <v-img
                        :src="calculatorInfo[1].image"
                    ></v-img>
                </v-col>
                <v-col cols="12" class="col-md-6 col-lg-5 pl-md-12 my-md-auto">
                    <p class="text-center text-md-left py-9 big-text">
                        {{ $t('homeCalculatorSubtitle2') }}
                    </p>
                    <div class="text-center text-md-left">
                        <v-btn
                            dark
                            depressed
                            outlined
                            class="body-1 px-10 test-white caption main--yellow"
                            :to="{ path: 'calculator' }"
                        >
                            {{$t('goToCalculator')}}
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-col>
</template>

<script>
    import AppVariables from '../../../app-front/mixins/AppVariables';
    import HomeButton from './HomeButton';
    import HomeTitle from './HomeTitle';

    export default {
        name: 'HomeCalculator',
        mixins: [AppVariables],
        components: {
            HomeButton,
            HomeTitle,
        },
        data() {
            return {
                calculatorInfo: [
                    { id: 1, image: this.getCdnPath() + '/images/calculator/1.png' },
                    { id: 2, image: this.getCdnPath() + '/images/calculator/2.png' },
                ],
            }
        },
    }
</script>
<style scoped lang="scss">

    @media (min-width: 1264px) {
        .big-text {
            font-size: 1.2rem !important;
            line-height: 1.7;
        }
    }
</style>
